import { Variable } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ResolverIcon = createLucideIcon(Variable);
